import { render, staticRenderFns } from "./enterpriseBranch.vue?vue&type=template&id=b3cb63d8&scoped=true"
import script from "./enterpriseBranch.vue?vue&type=script&lang=js"
export * from "./enterpriseBranch.vue?vue&type=script&lang=js"
import style0 from "./enterpriseBranch.vue?vue&type=style&index=0&id=b3cb63d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cb63d8",
  null
  
)

export default component.exports